import { RequestHandler } from 'msw';
import { worker } from './browser';

export const startMswForCurrentEnv = () => {
  worker.start({
    onUnhandledRequest: 'bypass',
  });
  // Add temporary MSW handlers for dev testing here, remove when API is implemented
  const handlers: RequestHandler[] = [];

  worker.use(...handlers);

  window.__mswStop = worker.stop;
};
